module.exports = __webpack_public_path__ + "static/media/arts_26.473beb5a.jpg";